import React from 'react';
import { SvgIcon, Typography } from '@mui/material';
import { ReactComponent as CloseIcon } from 'mui/assets/icons/close-icon-rounded.svg';
import { StyledChip } from './DS_ChipStyles';

/**
 * Render  DS_Chip
 *
 * @returns {React.ReactElement}
 */

const DS_Chip = ({ selected, text, children, handleClick, handleClose, transitional }) => {
  return (
    <StyledChip selected={selected} transitional={transitional} onClick={selected ? null : handleClick}>
      <Typography variant="DS_labelMediumBold" component="p" data-qa="chip">
        {children || text}
      </Typography>
      {selected ? (
        <SvgIcon
          data-qa="close-chip"
          component={CloseIcon}
          inheritViewBox={false}
          onClick={e => {
            e.stopPropagation();
            handleClose();
          }}
        ></SvgIcon>
      ) : null}
    </StyledChip>
  );
};

export default DS_Chip;
